/** URL building and error-envelope parsing for the API client. */
import { ApiError, codeForStatus, isErrorEnvelope } from './errors'

export type QueryValue = string | number | boolean | null | undefined

export function buildUrl(
  apiBase: string,
  path: string,
  query?: Readonly<Record<string, QueryValue>>,
): string {
  const base = `${apiBase}/${path.replace(/^\/+/, '')}`
  if (query === undefined) return base
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue
    params.set(key, String(value))
  }
  const encoded = params.toString()
  return encoded === '' ? base : `${base}?${encoded}`
}

/** Parses a non-2xx response into an ApiError (envelope, or transport fallback with the header request id). */
export async function toApiError(response: Response): Promise<ApiError> {
  const requestId = response.headers.get('x-request-id') ?? undefined
  const text = await response.text().catch(() => '')
  let body: unknown
  try {
    body = text === '' ? undefined : (JSON.parse(text) as unknown)
  } catch {
    body = undefined
  }
  if (isErrorEnvelope(body)) {
    const { code, message, details } = body.error
    return new ApiError({
      kind: 'api',
      status: response.status,
      code,
      message,
      details,
      requestId: body.request_id ?? requestId,
    })
  }
  return new ApiError({
    kind: 'transport',
    status: response.status,
    code: codeForStatus(response.status),
    message: `Unexpected response (HTTP ${String(response.status)}).`,
    requestId,
  })
}
